import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted webfonts for the Reef Modernism theme — no CDN request. Both are
// registered under reef-specific family names so the two themes that already
// name `Space Grotesk` and `IBM Plex Mono` without shipping them keep falling
// back to a system face exactly as before. See src/themes/reefFonts.css.
import '@fontsource-variable/space-grotesk';
import './themes/reefFonts.css';
import './index.css';
import App from './App';
import { applyDevAuthBypass } from './auth/devBypass';
import { initAnalytics } from './analytics/analytics';

// Seed a synthetic JWT into token storage when the dev bypass env flag is
// enabled. Gated behind `import.meta.env.DEV` so this is a no-op in any
// production build. Must run before ReactDOM.render so `authStore.checkAuth`
// picks the token up on first mount.
applyDevAuthBypass();

// Google Analytics — a no-op unless VITE_GA_MEASUREMENT_ID is set. Page views
// are sent per route by AnalyticsPageTracker (App.tsx).
initAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
